<div class="eula-container">
  <div class="eula-head">
    <div class="row">
      <img src="assets/img/logo/Transcriber_Logo.png" alt="acord_logo"  class="acord_logo">
      <!-- <div class="sh-acord-img">
        <img
          src="assets/img/logo/acord-logo.svg"
          alt="acord_logo"
          style="width: 100%; height: 28px"
        />
      </div>
      <div class="sh-line"></div>
      <div class="sh-transcriber-img">
        <img
          src="assets/img/logo/transcriber-logo.svg"
          alt="acord_logo"
          style="width: 100%; height: 35px"
        />
      </div> -->
    </div>
    <br/>
    <div class="adept-title">Welcome to ACORD Transcriber<div>
  </div>

  <div class="eula-content-container" id="eula-content-container" (scroll)="onScroll($event)">
    <div class="adept-terms-title">Terms of Service</div>
    <div id="eula-content" [innerHTML]="eulaContent | domSanitizer"></div>
  </div>

  <div class="eulaBtnGroup">
    <button type="button" class="disagree-eula-btn" (click)="onDisagree()">Disagree & Exit
      App</button>
    <button type="button" class="agree-eula-btn" [disabled]="agreeBtnDisabled" (click)="onAgree()">Agree</button>
  </div>

</div>
